<template>
    <div class="observations-tile d-flex flex-column">
        <ObservationRows v-if="expectedParticipants || participants.length > 0" :participants="participants"
            :expected-participants="expectedParticipants" @observation-changed="onObservationChanged" />
    </div>
</template>

<script setup>
import ObservationRows from "@/components/classroom/sidePanel/observations/ObservationRows.vue";

const props = defineProps({
    participants: Object,
    expectedParticipants: Object
});

const emit = defineEmits(['observationChanged']);

function onObservationChanged(data) {
    emit('observationChanged', data);
}

</script>

<style lang="scss">
@import '@/styles/variables.scss';

.observations-tile {
    padding: 2vh;
}
</style>